import React from 'react';
import { useNavigate } from 'react-router-dom';

const FinalGradeGuide: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      background: 'white',
      position: 'relative'
    }}>
      {/* 메인 컨텐츠 영역 */}
      <main style={{
        width: '100%',
        paddingTop: '0',
        position: 'relative'
      }}>
        {/* 히어로 섹션 */}
        <div style={{
          width: '100%',
          height: '300px',
          position: 'relative',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '24px',
            display: 'flex',
            zIndex: 10
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <div style={{
                color: 'white',
                fontSize: '48px',
                fontFamily: 'pretendard',
                fontWeight: '700',
                lineHeight: '72px'
              }}>
                학년 말 전체 성적표 사용법
              </div>
              <div style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '20px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '30px'
              }}>
                학년 말 전체 성적표 작성 방법을 단계별로 안내합니다.
              </div>
            </div>
          </div>
        </div>

        {/* 사전 작업 섹션 */}
        <div style={{
          width: '100%',
          paddingTop: '80px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '40px'
          }}>
            {/* 섹션 타이틀 */}
            <div style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '8px',
              display: 'flex'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '36px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '54px'
            }}>
              사전 작업
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              학년 말 전체 성적표 작성을 위한 사전 작업을 진행합니다.
            </div>
          </div>

          {/* 작업 단계 */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            width: '100%'
          }}>
            {/* 단계 1 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--Color-fill-brand-color, #FF6F0F)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  1
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  ADMIN 시트 설정
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                ADMIN 시트의 학년, 반, 번호, 이름을 수정해주세요.
              </div>
            </div>

            {/* 단계 2 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--Color-fill-brand-color, #FF6F0F)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  2
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  성적 불러오기
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                ADMIN 시트의 "성적 불러오기" 버튼을 눌러 성적을 불러와주세요. 파일을 다 열어보기에 시간이 꽤 걸릴 수 있습니다.<br />
                ※ 처음 버튼을 누르면 교과군별 평가기준 성취수준 폴더를 설정해야 합니다. 해당 학년의 교과군별 평가기준 성취수준 폴더를 찾아 연결해주세요.
              </div>
            </div>

            {/* 단계 3 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--Color-fill-brand-color, #FF6F0F)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  3
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  개인별성적표 시트 확인
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                개인별성적표 시트에서 학생별 성적을 확인, 조회할 수 있습니다.
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* 개인별 성적표 사용법 섹션 */}
        <div style={{
          width: '100%',
          paddingTop: '80px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '40px'
          }}>
            {/* 섹션 타이틀 */}
            <div style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '8px',
              display: 'flex'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '36px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '54px'
            }}>
              개인별성적표 사용법
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              개인별성적표 시트에서 개인별 성적표를 출력하는 방법을 안내합니다.
            </div>
          </div>

          {/* 작업 단계 */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            width: '100%'
          }}>
            {/* 단계 1 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid #667eea'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#667eea',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  1
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  반 명렬 불러오기
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                C2셀에 불러올 반의 숫자를 기입하시고 나서 "학생 불러오기" 버튼을 눌러주세요.
              </div>
            </div>

            {/* 단계 2 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid #667eea'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#667eea',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  2
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  학생 성적표 조회하기
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                학생의 번호 혹은 이름을 선택한 뒤, "성적표 조회" 버튼을 눌러주세요.<br />
                만일 번호 혹은 이름을 선택하지 않고 버튼을 누른 경우, 조회할 학생의 번호를 입력하면 성적표를 조회할 수 있습니다.
              </div>
            </div>

            {/* 단계 3 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid #667eea'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#667eea',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  3
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  학교 로고 및 이름 변경하기
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                (Office 365 버전만 가능합니다.)<br />
                B11셀의 이미지를 삭제 한 뒤 소속교 로고 이미지의 오른쪽 모서리를 B11셀에 두고 ✉️ 아이콘을 눌러주세요.<br />
                C11셀의 학교 이름을 수정해주세요.
              </div>
            </div>

            {/* 단계 4 */}
            <div style={{
              padding: '32px',
              background: 'var(--Color-background-sub, #F8F8F8)',
              borderRadius: '12px',
              borderLeft: '4px solid #667eea'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#667eea',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  4
                </div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '20px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '30px'
                }}>
                  성적표 내보내기(인쇄, PDF 등)
                </div>
              </div>
              <div style={{
                color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                fontSize: '16px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '28px',
                paddingLeft: '56px'
              }}>
                조회하고 있는 학생의 성적표를 내보내거나 인쇄하고 싶으신 경우 "해당 학생 내보내기" 버튼을,<br />
                해당 반의 모든 학생의 성적표를 인쇄하고 싶으신 경우 "반 전체 내보내기" 버튼을 눌러주세요.
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          width: '100%',
          height: '120px',
          padding: '32px 80px',
          background: 'var(--Color-fill-normal, #293044)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '80px'
        }}>
          <div style={{
            textAlign: 'center',
            color: 'var(--Color-text-assistive, #989898)',
            fontSize: '14px',
            fontFamily: 'pretendard',
            fontWeight: '400',
            lineHeight: '21px'
          }}>
            서울시교육청 IB 성적처리 시스템 | 문의: jihotech16@outlook.kr (교사 한지호)<br />
            @Maru Corp. All rights reserved.
          </div>
        </div>
      </main>
    </div>
  );
};

export default FinalGradeGuide;
